/**
 * 사람
 */
import { Fragment } from 'react';
import { CUR_NETWORK, PROFILE_IMG_DOMAIN, SANDBOX_DOMAIN } from '@constants/index';
import { numberWithCommas } from '@utils/index';
import type { INpUser, ISetNpUser, l10nType } from '@type/index';

export const setNpUserItem = (item: INpUser): ISetNpUser | null => {
  return item && typeof item === 'object'
    ? {
        ...item,
        url: `${SANDBOX_DOMAIN[CUR_NETWORK]}/${item?.userId}`,
        thumbnailUrl: `${PROFILE_IMG_DOMAIN[CUR_NETWORK]}/account_profile_images/${item?.userId}`,
        friendCount: numberWithCommas(item?.friendCount),
        followerCount: numberWithCommas(item?.followerCount),
      }
    : null;
};

const NpUserArticle = ({ item, l10n }: { item: INpUser; l10n: l10nType }) => {
  const data = setNpUserItem(item);

  if (!data) {
    return <Fragment />;
  }

  const { url, thumbnailUrl, userName, friendCount, followerCount, prflIntro } = data;
  return (
    <div className="search-item-content">
      <div className="search-item-thumbnail">
        <a href={url} className="result-items-thumb result-thumb-circle npuser-thumb">
          <figure style={{ backgroundImage: `url(${thumbnailUrl})` }}></figure>
        </a>
      </div>
      <div className="search-item-article">
        <div className="search-item-title">
          <a href={url} dangerouslySetInnerHTML={{ __html: userName }}></a>
        </div>
        <div className="search-item-info">
          <span>NC친구 {friendCount}</span>
          <span>구독자수 {followerCount}</span>
        </div>
        <div className="search-item-info">{prflIntro}</div>
      </div>
    </div>
  );
};

export default NpUserArticle;
